import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button, Modal, Dropdown } from 'react-bootstrap';
import { getSubscriptionDetail, cancelSubscriptionAction, getInvoiceListAction } from './../../actions/SubscriptionAction';
import { reActivateSubscriptionAction } from './../../actions/ChangePlanActions';
import * as code from './../../config/Constants';
import { toastMessage, currencyFormat, getMonthName } from './../Common/Common';
import { HelpOutline,KeyboardArrowDown } from '@material-ui/icons';
import DataTable from 'react-data-table-component';
import noRecord from './../../assets/img/no-record.png';


var _ = require('lodash');

class SubscriptionDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            accountInfo: '',
            cancelPrompt: false,
            invoiceList: [],
        };
    }
    columns = [
        {
            name: 'Amount',
            selector: 'amount',
            sortable: true,
            width: '160px'
        },
        {
            name: 'Currency',
            selector: 'currency',
            sortable: true,
            width: '160px',
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
            width: '160px',
        },
        {
            name: 'Invoice Number',
            selector: 'invoicenumber',
            sortable: true,
            width: '160px',

        },
        {
            name: 'Created',
            selector: 'created',
            sortable: true,
            width: '160px',

        },
        {
            name: "",
            selector: "active",
            sortable: true,
            ignoreRowClick: true
        },
    ];
    componentWillMount() {
        this.getSubscriptionDetail();
        this.getInvoiceList();
    }
    getSubscriptionDetail() {
        this.setState({ showLoader: true });
        this.props.getSubscriptionDetail().then(res => {
            this.setState({ showLoader: false });
            if (res.status === code.OK) {
                this.setState({ accountInfo: res.data })
            }
        })
    }
    getInvoiceList() {
        this.setState({ showLoader: true });
        this.props.getInvoiceListAction().then(res => {
            this.setState({ showLoader: false });
            if (res.status === code.OK) {
                this.setState({ invoiceList: this.props.invoiceList })
            }
        })
    }
    /**
    * @desc cancel plan
    */
    cancelSubscription() {
        this.setState({ showLoader: true });
        this.props.cancelSubscriptionAction().then(res => {
            this.setState({ showLoader: false });
            this.cancelPrompt();
            if (res.status === code.OK) {
                toastMessage(code.SUCCESS, "Your plan is canceled");
            }
            this.getSubscriptionDetail();
        })
    }
    /**
    * @desc reactivate plan
    */
    reActivateSubscription() {
        this.setState({ showLoader: true });
        this.props.reActivateSubscriptionAction().then(res => {
            if (res.status === code.OK) {
                toastMessage(code.SUCCESS, "Your plan is activated successfully");
            }
            this.getSubscriptionDetail();
        })
    }
    /**
    * @desc open/close cancel promt
    */
    cancelPrompt() {
        this.setState({
            cancelPrompt: !this.state.cancelPrompt,
        })
    }
    render() {
        let rows = [];

        let invoiceList = this.state.invoiceList || []
        for (var i = 0, len = invoiceList.length; i < len; i++) {
            let invoice = invoiceList[i];

            let data = {
                amount: currencyFormat(invoice.amount_due),
                currency: (invoice.currency).toUpperCase(),
                status: invoice.status,
                invoicenumber: invoice.number,
                created: invoice.created,
                active: (
                    <Button
                        variant="primary"
                        className={"btn-blue btn-grid "}
                        onClick ={()=> window.location.href =invoice.downloadPDFURL}
                    >
                        Download
                    </Button>
                ),

            }

            rows.push(data);
        }

        if (this.state.showLoader) {
            return (
                <div className="page-loader fixed">
                    <div className="page-loader-inner">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            )
        }
        else {

            return (
                <>
                    <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
                        <Col className="col-auto">
                            <h4 className="title-med mt-0 pt-1">Manage Plan</h4>
                        </Col>
                    </Row>
                    <div className="subscription-detail">

                        <Row className="card-row header">
                            <Col md={2}>Plan</Col>
                            <Col md={2}>Status</Col>
                            <Col md={2}>Price</Col>
                            <Col md={2}>Payment Due</Col>
                            <Col md={2}>Payment Mode</Col>
                            <Col md={2}>Actions</Col>
                        </Row>
                        <Row className="card-row content">
                            <Col md={2}>{!!this.state.accountInfo.subscriptionSummary ? this.state.accountInfo.subscriptionSummary.productName : ''}</Col>
                            <Col md={2} className={!!this.state.accountInfo.subscriptionSummary ? this.state.accountInfo.subscriptionSummary.status === "active" ? "active-plan" : "inactive-plan" : ""}>{!!this.state.accountInfo.subscriptionSummary ? (this.state.accountInfo.subscriptionSummary.status).toUpperCase() : ''}</Col>
                            <Col md={2}>{!!this.state.accountInfo.subscriptionSummary ? !this.state.accountInfo.subscriptionSummary.isCancelAtPeriodEnd && localStorage.getItem("isActive") === "true" ? currencyFormat(this.state.accountInfo.subscriptionSummary.nextInvoiceAmount / 100) : '-' : ''}</Col>
                            <Col md={2}>{!!this.state.accountInfo.subscriptionSummary ? !this.state.accountInfo.subscriptionSummary.isCancelAtPeriodEnd && localStorage.getItem("isActive") === "true" ? this.state.accountInfo.subscriptionSummary.nextInvoiceDate : '-' : ''}</Col>
                            {!!this.state.accountInfo.paymentMethods ? this.state.accountInfo.paymentMethods.map(card => {
                                if (card.isDefault) {
                                    return (
                                        <Col md={2}>
                                            <ul className="cc-info">
                                                <li className="generic_card">
                                                    <p className="cc-vendor">{card.brand}&nbsp;{"****" + card.number}</p>
                                                    <p className="cc-expiry">Expires {getMonthName(card.expireMonth - 1)}&nbsp;{card.expireYear} </p>
                                                </li>
                                            </ul>
                                        </Col>)
                                }
                            }) : ''}
                            <Col md={2}>
                                {!!this.state.accountInfo.subscriptionSummary ? this.state.accountInfo.subscriptionSummary.status !== "canceled" && this.state.accountInfo.subscriptionSummary.status !== 'incomplete_expired' ?
                                    <p className="action-para" onClick={() => { this.props.history.push("/Subscription/ChangePlan"); }}>Change Plan</p> : '' : ''}
                                {!!this.state.accountInfo.subscriptionSummary ?
                                    this.state.accountInfo.subscriptionSummary.status !== "canceled" && this.state.accountInfo.subscriptionSummary.status !== 'incomplete_expired' ?
                                        this.state.accountInfo.subscriptionSummary.isCancelAtPeriodEnd ? <p className="action-para" onClick={() => { this.reActivateSubscription() }}>Don't Cancel</p> :
                                            <p className="action-para" onClick={() => { this.cancelPrompt() }}>Cancel Plan</p> :
                                        <p className="action-para" onClick={() => { this.props.history.push("/Subscription/ActivatePlan"); }}>Activate Plan</p>
                                    : ''}
                                <p className="action-para" onClick={() => { this.props.history.push("/Subscription/ManagePayment"); }}>Manage Payment</p>

                            </Col>
                        </Row>
                        <Row className="ml-0 mr-0  align-items-center">
                        <Col className="col-auto">
                            <h4 className="title-med mt-0 pt-1">Previous Purchase History</h4>
                        </Col>
                        </Row>
                        <div className="dt-content-area">
                            <DataTable
                                columns={this.columns}
                                data={rows}
                                sortIcon={<KeyboardArrowDown className="color-grey-1" />}
                                noDataComponent={
                                    <div className="no-transaction no-record no-datatable">
                                        <div className="no-transaction-inner">
                                            <img src={noRecord} alt="no record" />
                                            <p>No Invoice Found</p>
                                        </div>
                                    </div>
                                }
                                highlightOnHover={true}
                                className="rdt-requests"
                            />
                        </div>
                        <Modal
                            show={this.state.cancelPrompt}
                            dialogClassName="modal-90w"
                            aria-labelledby="example-custom-modal-styling-title"
                            className="modal-med modal-400 modal-delete"
                            centered
                            backdrop={false}
                        >
                            <Modal.Body className="pb-0 text-center">
                                <HelpOutline />
                                <p>Are you sure you want to cancel your plan?</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant='primary' className="btn-blue btn-outlined w-140" onClick={() => { this.cancelPrompt() }}>Cancel</Button>
                                <Button variant='primary' className="btn-blue w-140" onClick={() => { this.cancelSubscription() }}>Yes</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </>);
        }
    }

}
const mapStateToProps = state => {
    return {
        accountInfo: state.reducer.accountInfo,
        invoiceList: state.reducer.invoiceList,
    };
};
export default connect(mapStateToProps, { getSubscriptionDetail, cancelSubscriptionAction, reActivateSubscriptionAction, getInvoiceListAction })(SubscriptionDetail);
